import { Box, Stack } from "@mui/material";
import { GetServerSideProps } from "next";
import Head from "next/head";
import { useState } from "react";

import { fetchProspectusPackages } from "../../api";
import { FetchProspectusPackagesResponse } from "../../api/fetchProspectusPackages/fetchProspectusPackages";
import { Nav, Viewer } from "../../components";

export const getServerSideProps: GetServerSideProps = async (context) => {
  let cusip: string;
  const { params } = context;

  if (params?.cusip) {
    if (typeof params.cusip === "string") {
      cusip = params.cusip;
    } else {
      cusip = params.cusip[0];
    }

    try {
      const { data } = await fetchProspectusPackages(cusip);

      return {
        props: {
          prospectusPackages: data,
        },
      };
    } catch (error) {
      console.error(error);

      return { notFound: true };
    }
  }

  return {
    notFound: true,
  };
};

export interface ICusipProps {
  prospectusPackages: FetchProspectusPackagesResponse;
}

const Cusip = ({ prospectusPackages }: ICusipProps) => {
  const [selectedDocumentIndex, setSelectedDocumentIndex] = useState(0);

  const { documents, security } = prospectusPackages;
  const { issuerName, ticker } = security;
  const selectedDocument = documents[selectedDocumentIndex];
  const { name: documentName } = selectedDocument;

  const handleSelectDocument = (document: number) => {
    setSelectedDocumentIndex(document);
  };

  const getTitle = () => {
    if (ticker) {
      return `${ticker} ${documentName}`;
    }
    return documentName;
  };

  return (
    <Stack height="100%">
      {/* enable this once the broker route is setup and product decides
      on whether to show broker
      <Header brokerLogo={broker.logo} brokerName={broker.name} /> */}
      <Head>
        <title data-testid="head-title">{getTitle()}</title>
      </Head>
      <Nav
        issuerName={issuerName}
        issuerTicker={ticker}
        documents={documents}
        selectedDocument={selectedDocumentIndex}
        onSelectDocument={handleSelectDocument}
      />
      <Box sx={{ flex: 1 }}>
        <Viewer doc={selectedDocument} />
      </Box>
    </Stack>
  );
};

export default Cusip;
